import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import NewsCard from "@/components/feature/NewsCard";
import type { NewsItem } from "@/mocks/news";

interface NewsHighlightProps {
  items: NewsItem[];
  onOpen: (item: NewsItem) => void;
}

export default function NewsHighlight({ items, onOpen }: NewsHighlightProps) {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Latest News"
          title="明星资讯精选"
          description="掌握佐佐木明希最新动态、活动记录与深度访谈，第一时间了解她的每一步。"
          action={
            <Link
              to="/news"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-5 py-2.5 text-sm font-label font-medium text-primary-700 transition-colors hover:bg-primary-50"
            >
              查看全部资讯
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          }
        />

        {items.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center">
            <i className="ri-newspaper-line text-3xl text-foreground-400" aria-hidden="true" />
            <p className="mt-3 text-sm text-foreground-500">暂无相关新闻</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
            {items.map((item) => (
              <NewsCard key={item.id} item={item} onOpen={onOpen} layout="row" />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}